import { render, staticRenderFns } from "./TheHero.vue?vue&type=template&id=14f32318&scoped=true"
import script from "./TheHero.vue?vue&type=script&lang=js"
export * from "./TheHero.vue?vue&type=script&lang=js"
import style0 from "./TheHero.vue?vue&type=style&index=0&id=14f32318&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f32318",
  null
  
)

export default component.exports